export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-20 md:py-28" style={{ background: '#f8f9fb' }}>
      <div className="max-w-2xl mx-auto px-6 flex flex-col items-center text-center gap-10">

        {/* Section Label */}
        <div className="flex flex-col items-center gap-3">
          <p
            className="text-xs tracking-[0.3em] font-medium"
            style={{ color: '#AAC4DC', fontFamily: "'Cormorant Garamond', serif" }}
          >
            CONTACT
          </p>
          <h2
            className="text-2xl md:text-3xl tracking-widest font-light"
            style={{ color: '#333', fontFamily: "'Noto Serif JP', serif" }}
          >
            お問い合わせ
          </h2>
          <div className="w-10 h-px mt-1" style={{ background: '#AAC4DC' }} />
        </div>

        {/* Message */}
        <p
          className="text-sm md:text-base leading-loose tracking-wide"
          style={{ color: '#666', fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          ご不明な点やご質問など、<br className="sm:hidden" />
          お気軽に店舗 Instagram DM にてお問い合わせください。
        </p>

        {/* Instagram Link */}
        <a
          href="https://www.instagram.com/uru_sakuragi/"
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-center gap-4 px-8 py-4 rounded-full cursor-pointer transition-all duration-300 whitespace-nowrap"
          style={{
            background: 'linear-gradient(135deg, #AAC4DC 0%, #8fb3d0 100%)',
            color: '#fff',
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLAnchorElement).style.opacity = '0.85';
            (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLAnchorElement).style.opacity = '1';
            (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
          }}
        >
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-instagram-line text-xl" />
          </div>
          <span
            className="text-sm tracking-widest font-medium"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            Instagram DM でお問い合わせ
          </span>
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-line text-sm transition-transform duration-300 group-hover:translate-x-1" />
          </div>
        </a>

        {/* Sub note */}
        <p className="text-xs tracking-wide" style={{ color: '#aaa' }}>
          @uru_sakuragi
        </p>
      </div>
    </section>
  );
}
